import React from 'react';
import { Spin } from 'antd';
import { WifiOutlined } from '@ant-design/icons';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { AnnouncementSelectSiteController } from 'fragments/announcements/interfaces';
import { useAnnouncementSelectSiteController } from 'fragments/announcements/announcement-select-site.controller';
import 'fragments/announcements/announcements-list.scss';

interface AnnouncementSelectSiteFragmentProps {
    useController?: () => AnnouncementSelectSiteController;
}

export const AnnouncementSelectSiteFragment: React.FC<AnnouncementSelectSiteFragmentProps> = ({
    useController = useAnnouncementSelectSiteController,
}) => {
    const { translate } = useTranslator();
    const { state, events } = useController();

    return (
        <div className={'announcements-list'}>
            <div className={'announcements-header'}>
                <h1 className={'announcements-header-title'}>
                    {translate({ key: 'announcements.select-site-title' })}
                </h1>
            </div>

            {state.loading ? (
                <Spin className={'announcements-spin'} />
            ) : state.error ? (
                <div className={'announcements-error'} role={'alert'}>
                    <WifiOutlined aria-hidden />
                    <span className={'announcements-error-text'}>
                        {translate({ key: 'announcements.select-site-error' })}
                    </span>
                    <button type={'button'} className={'announcements-error-retry'} onClick={events.onRetry}>
                        {translate({ key: 'announcements.retry' })}
                    </button>
                </div>
            ) : (
                <div className={'announcements-cards'}>
                    {state.sites.map((site) => (
                        <button
                            key={site.siteId}
                            type={'button'}
                            className={'announcements-card'}
                            onClick={() => events.onSelect(site.siteId)}
                        >
                            <span className={'announcements-card-title'}>{site.siteName}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
